import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import Tooltip from '@mui/material/Tooltip';
import { useAppDispatch } from '../../../../hooks';
import {
  refreshOrderFlow,
  refreshServiceLogSummary,
  refreshServiceMonitorSummary,
} from '../../../../slices/utils/utilsSlice';

export default function RefreshAll() {
  const dispatch = useAppDispatch();
  const handleRefreshAll = () => {
    dispatch(refreshOrderFlow(true));
    dispatch(refreshServiceLogSummary(true));
    dispatch(refreshServiceMonitorSummary(true));
  };

  return (
    <Tooltip title="Refresh All">
      <IconButton onClick={handleRefreshAll}>
        <Icon>refresh</Icon>
      </IconButton>
    </Tooltip>
  );
}
